import { render, staticRenderFns } from "./MspCoupon.vue?vue&type=template&id=8f6d8c9a"
import script from "./MspCoupon.vue?vue&type=script&lang=js"
export * from "./MspCoupon.vue?vue&type=script&lang=js"
import style0 from "./MspCoupon.vue?vue&type=style&index=0&id=8f6d8c9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports